import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface TeamOverviewProps {
  workspaceName: string;
  planType: string;
  maxSeats: number;
}

export function TeamOverview({ workspaceName, planType, maxSeats }: TeamOverviewProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{workspaceName}</CardTitle>
        <CardDescription>
          Plan: <span className="font-medium capitalize">{planType}</span>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="text-sm text-muted-foreground">
          Maximale Sitze: <span className="font-medium">{maxSeats}</span>
        </div>
      </CardContent>
    </Card>
  );
}
